import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export default function DoctorInfoSection({ doctor }) {
  const { t } = useTranslation();

  return (
    <StyledDoctorInfoSection>
      <div className="container">
        <div className="doctor-info-sect__wrap">
          <div className="doctor-info-sect__left">
            <div className="doctor-info-sect__left__top">
              <div className="doctor-info-sect__left__img">
                <div>
                  <img
                    src={doctor.img}
                    alt={t(doctor.name)}
                    style={{
                      "--doctor-img-position":
                        doctor.imagePosition || "center top",
                    }}
                  />
                </div>
                <ul>
                  <li>
                    <a href={doctor.socials.facebook}>
                      <i className="icon icon-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={doctor.socials.instagram}>
                      <i className="icon icon-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={doctor.socials.twitter}>
                      <i className="icon icon-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a href={doctor.socials.telegram}>
                      <i className="icon icon-telegram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="doctor-info-sect__left__bottom">
              <div className="doctor-info-sect__left__contact">
                <h1>
                  <i className="icon icon-contact"></i>
                  <b>{t("doctorSingleContact")}</b>
                </h1>
                <ul>
                  <li>
                    <i className="icon icon-phone"></i>
                    <a
                      href={"tel:" + doctor.contact.phone}
                      className="hover-underline"
                    >
                      {doctor.contact.phone}
                    </a>
                  </li>
                  <li>
                    <i className="icon icon-mail"></i>
                    <a
                      href={"mailto:" + doctor.contact.mail}
                      className="hover-underline"
                    >
                      {doctor.contact.mail}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="doctor-info-sect__left__degree">
                <h1>
                  <i className="icon icon-award"></i>
                  <b>{t("doctorSingleAwards")}</b>
                </h1>
                <ul>
                  {doctor.awards.map((i, idx) => (
                    <li key={idx}>
                      <h2>{t(i)}</h2>
                    </li>
                  ))}
                </ul>
              </div>
              {/* <div className="doctor-info-sect__left__schedule">
                <h1>
                  <i className="icon icon-calendar-schedule"></i>
                  <b>{t("doctorSingleSchedules")}</b>
                </h1>
                <ul>
                  {doctor.schedules.map((item) => (
                    <li key={item.id}>
                      <h1>{t(item.title)}</h1>
                      <p>
                        <i className="icon icon-time"></i>
                        <b>{item.time}</b>
                      </p>
                    </li>
                  ))}
                </ul>
              </div> */}
            </div>
          </div>
          <div className="doctor-info-sect__right">
            <div className="doctor-info-sect__right__bio">
              <h1>Dr. {t(doctor.name)}</h1>
              <p>{t(doctor.specialist)}</p>
              <p>{t(doctor.bio)}</p>
            </div>
            <div className="doctor-info-sect__right__degree">
              <h1>
                <i className="icon icon-work-bag"></i>
                <b>{t("doctorSingleExperiences")}</b>
              </h1>
              <ul>
                {doctor.experience.map((i, idx) => (
                  <li key={idx}>
                    <h2>{t(i)}</h2>
                  </li>
                ))}
              </ul>
            </div>
            <div className="doctor-info-sect__right__degree">
              <h1>
                <i className="icon icon-degree"></i>
                <b>{t("doctorSingleDegrees")}</b>
              </h1>
              <ul>
                {doctor.degrees.map((i) => (
                  <li key={i.id}>
                    <h2>{t(i.univer)}</h2>
                    <p>{t(i.specialty)}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </StyledDoctorInfoSection>
  );
}

const StyledDoctorInfoSection = styled.section`
  background-color: var(--white);
  padding: 140px 0;

  .doctor-info-sect {
    &__wrap {
      display: grid;
      grid-template-columns: minmax(360px, 560px) minmax(0, 1fr);
      gap: 96px;
      align-items: start;
    }

    &__left {
      &__top {
        margin-bottom: 64px;
      }

      &__img {
        width: min(560px, 100%);


        div {
          line-height: 0;
          width: 100%;
          aspect-ratio: 3 / 4;
          overflow: hidden;
          border: 1px solid var(--border);
          background-color: var(--light-bg);


          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: var(--doctor-img-position, center top);
            display: block;
          }
        }

        ul {
          width: 100%;
          box-sizing: border-box;
          padding: 18px 20px;
          border-radius: 0 0 18px 18px;
          background-color: var(--dark-blue);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 32px;

          li {
            a {
              i {
                width: 30px;
                height: 30px;

                &:hover {
                  transform: scale(1.15) rotate(9deg);
                }
              }
            }
          }
        }
      }

      &__contact {
        margin-bottom: 72px;

        h1 {
          display: flex;
          align-items: center;
          gap: 24px;
          margin-bottom: 24px;

          i {
            background-color: var(--dark-blue);
          }

          b {
            color: var(--title);
            font-size: var(--fs-card-title);
            font-style: normal;
            font-weight: var(--fw-semibold);
            line-height: 1.35;
          }
        }

        ul {
          display: flex;
          flex-direction: column;
          gap: 24px;
          padding-left: 48px;

          li {
            display: flex;
            align-items: center;
            gap: 12px;

            i {
              background-color: var(--dark-blue);
              width: 14px;
              height: 14px;
            }

            a {
              color: var(--text);
              font-size: var(--fs-body-sm);
              font-style: normal;
              font-weight: var(--fw-medium);
              line-height: var(--lh-body);

              &::after {
                height: 1.5px;
                background-color: var(--text);
              }
            }
          }
        }
      }

      &__degree {
        h1 {
          display: flex;
          align-items: center;
          gap: 24px;
          margin-bottom: 24px;

          b {
            color: var(--title);
            font-size: var(--fs-card-title);
            font-style: normal;
            font-weight: var(--fw-semibold);
            line-height: 1.35;
          }

          i {
            background-color: var(--dark-blue);
            min-width: 24px;
          }
        }

        ul {
          margin-left: 48px;
          display: flex;
          flex-direction: column;
          gap: 24px;

          li {
            padding-left: 28px;

            h2 {
              color: var(--title);
              font-size: var(--fs-body-sm);
              font-style: normal;
              font-weight: var(--fw-medium);
              line-height: var(--lh-body);
              margin-bottom: 4px;
              position: relative;

              &::before {
                content: "";
                position: absolute;
                top: 7px;
                left: -24px;
                width: 10px;
                height: 10px;
                background-color: var(--dark-blue);
                border-radius: 50%;
              }
            }

            p {
              color: var(--text);
              font-size: var(--fs-body-sm);
              font-style: normal;
              font-weight: var(--fw-regular);
              line-height: var(--lh-body);
              opacity: 0.6;
            }
          }
        }
      }

      &__schedule {
        h1 {
          display: flex;
          align-items: center;
          gap: 24px;

          i {
            background-color: var(--dark-blue);
          }

          b {
            color: var(--title);
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px; /* 108.333% */
          }
        }

        ul {
          margin-top: 24px;
          margin-left: 48px;
          border-radius: 20px;
          background: var(--white);
          /* box-shadow: 0px 2px 10px 1px rgba(113, 181, 248, 0.1); */
          padding: 30px 45px;
          display: flex;
          flex-direction: column;
          gap: 24px;
          border: 1px solid var(--border);

          li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 24px;

            h1 {
              color: var(--title);
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: 24px; /* 162.5% */
            }

            p {
              display: flex;
              align-items: center;
              gap: 12px;

              i {
                background-color: var(--dark-blue);
                width: 20px;
                height: 20px;
              }

              b {
                color: var(--text);
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px; /* 162.5% */
              }
            }
          }
        }
      }
    }

    &__right {
      padding-top: 60px;
      display: flex;
      flex-direction: column;
      gap: 72px;

      &__bio {
        
        h1 {
          color: var(--title);
          font-size: var(--fs-section-title);
          font-style: normal;
          font-weight: var(--fw-semibold);
          line-height: var(--lh-title);
          margin-bottom: 12px;
        }

        p {
          &:first-of-type {
            color: var(--light-blue);
            font-size: var(--fs-subtitle);
            font-style: normal;
            font-weight: var(--fw-medium);
            line-height: var(--lh-subtitle);
            margin-bottom: 32px;
          }

          &:last-of-type {
            color: var(--text);
            font-size: var(--fs-body);
            font-style: normal;
            font-weight: var(--fw-regular);
            line-height: var(--lh-body);
            text-align: left;
          }
        }
      }

      &__degree {
        h1 {
          display: flex;
          align-items: center;
          gap: 24px;
          margin-bottom: 24px;

          b {
            color: var(--title);
            font-size: var(--fs-card-title);
            font-style: normal;
            font-weight: var(--fw-semibold);
            line-height: 1.35;
          }

          i {
            background-color: var(--dark-blue);
          }
        }

        ul {
          margin-left: 48px;
          display: flex;
          flex-direction: column;
          gap: 24px;

          li {
            padding-left: 28px;

            h2 {
              color: var(--title);
              font-size: var(--fs-body);
              font-style: normal;
              font-weight: var(--fw-medium);
              line-height: var(--lh-body);
              margin-bottom: 4px;
              position: relative;

              &::before {
                content: "";
                position: absolute;
                top: 7px;
                left: -24px;
                width: 10px;
                height: 10px;
                background-color: var(--dark-blue);
                border-radius: 50%;
              }
            }

            p {
              color: var(--text);
              font-size: var(--fs-body-sm);
              font-style: normal;
              font-weight: var(--fw-regular);
              line-height: var(--lh-body);
              opacity: 0.9;
            }
          }
        }
      }
    }
  }

  @media (max-width: 992px) {
    .doctor-info-sect {
      &__wrap {
        grid-template-columns: 1fr;
        gap: 64px;
      }

      &__left__img {
        width: min(420px, 100%);
        margin: 0 auto;
      }

      &__right {
        padding-top: 0;
      }
    }
  }

  @media (max-width: 480px) {
    .doctor-info-sect {
      &__left__img {
        width: 100%;

        div {
          aspect-ratio: 3 / 4;
        }
      }
    }
  }
`;
